import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "A method for estimating the Thiele and Small parameters of an electrodynamic loudspeaker is presented below. Navigate with the arrows to discover it!",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 2,
      rows: 3,
      colsSize: [1, 1],
      rowsSize: [1, 3, 1],
      colSpan: {
        "0:0": 2,
      },
      rowSpan: {
        "1:1": 2,
      },
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "V<sub style='text-transform:none'>as</sub> measurement: closed enclosure method",
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    fontSize: "14px",
                    lineHeight: "22px",
                    fontWeight: 800,
                    letterSpacing: "0.25em",
                    textTransform: "uppercase",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/04/19/principle/slide-5.svg`,
                },
              },
              styles: {
                paddingBottom: "10%",
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: `<ol>
                  <li>Mount the lousdpeaker on a closed box of Volume V<sub>b</sub>
                  <li>Measure the electrical impedance for that configuration
                  <li>From the impedance curve, get the values of the resonance frequency f<sub>c</sub> and the electrical quality factor Q<sub>ec</sub> with the method explained before.
                  <li>Then, calculate V<sub>as</sub> using:</br>
                  <math display=inline xmlns=http://www.w3.org/1998/Math/MathML>
                  <msub> <mrow> <mi>V</mi> </mrow> <mrow> <mi>as</mi> </mrow> </msub>
                  <mo>=</mo> <mo>(</mo>
                  <mfrac>
                  <mrow> <msub> <mrow> <mi>f</mi> </mrow> <mrow> <mi>c</mi> </mrow> </msub> <msub> <mrow> <mi>Q</mi> </mrow> <mrow> <mi>ec</mi> </mrow> </msub></mrow>
                  <mrow> <msub> <mrow> <mi>f</mi> </mrow> <mrow> <mi>s</mi> </mrow> </msub> <msub> <mrow> <mi>Q</mi> </mrow> <mrow> <mi>es</mi> </mrow> </msub> </mrow>
                  </mfrac> <mo>-</mo> <mn>1</mn> <mo>)</mo>
                  </math>
                  </ol>`,
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    fontSize: "14px",
                    lineHeight: "20px",
                    fontWeight: 400,
                  },
                },
              },
              styles: {
                alignItems: "flex-start",
              },
            },
          },
        ],
        [],
      ],
    },
  },
};

export default principle;
